import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { HeroConversationMessage } from '@vs-online-only-app/state';
import useMessageTimestamp from '../../hooks/useMessageTimestamp';

type Props = {
  message: HeroConversationMessage;
};

const TimestampMessage: FC<Props> = ({ message }) => {
  const messageTimestamp = useMessageTimestamp(message.dateCreated);
  return (
    <>
      <Box minHeight={(theme) => theme.spacing(3.5)} />
      <Typography variant="caption" color="textSecondary" sx={{ opacity: 0.5 }}>
        {messageTimestamp}
      </Typography>
      <Box minHeight={(theme) => theme.spacing(1.5)} />
    </>
  );
};

export default TimestampMessage;
